<script>
    import { apiCore }  from '../../../../constants'
    import axios from 'axios'
    import Swal from "sweetalert2"
    import { authWellyMethods } from "@/state/helpers";
    export default {
        components: {},
        props: {
            product: {
                type: Object,
                default: null,
            },
            reloadProducts:{
                type: Function
            }
        },
        data() {
            return {
                selected: 1,
                user: null,
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            cleanDetail(){
                this.selected = 0;
            },
            setSelected(selected) {
                this.selected = selected;
            },
            closeModal(){
                this.$bvModal.hide('offers')
            },
            applyDisccount(){
                
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                
                if(this.selected == 1){
                    // quiere decir que le esta quitando la promo o estableciendo sin promo al platillo
                    let url = `${apiCore}/api/dish/${this.product._id}/inactivePromo`
                    axios
                    .put(url, {}, {
                            headers: {'Authorization': tok},
                    })
                    .then(r => r.data)
                    .then(res => {
                        if (res.valid) {
                            Swal.fire({
                                position: "top-end",
                                icon: "success",
                                title: "Se aplica la no promoción de tu platillo.",
                                showConfirmButton: false,
                                timer: 4500
                            });
                            this.reloadProducts()
                        }else{
                            Swal.fire({
                                position: "top-end",
                                icon: "warning",
                                title: "No se ha podido aplicar la promoción al platillo.",
                                showConfirmButton: false,
                                timer: 4500
                            });
                        }
                        this.$bvModal.hide('offers')
                    })
                }else{
                    let url = `${apiCore}/api/dish/${this.product._id}/addPromo`
                    let bodyDisccount = {
                        "discount": ""
                    }
                    if(this.selected == 2)
                        bodyDisccount.discount = "5"
                    if(this.selected == 3)
                        bodyDisccount.discount = "10"
                    if(this.selected == 4)
                        bodyDisccount.discount = "15"
                    if(this.selected == 5)
                        bodyDisccount.discount = "20"
                    if(this.selected == 6)
                        bodyDisccount.discount = "25"
                    if(this.selected == 7)
                        bodyDisccount.discount = "50"
                    if(this.selected == 8)
                        bodyDisccount.discount = "2x1"
                    axios
                    .put(url, bodyDisccount, {
                            headers: {'Authorization': tok},
                    })
                    .then(r => r.data)
                    .then(res => {
                        if (res.valid) {
                            Swal.fire({
                                position: "top-end",
                                icon: "success",
                                title: "Promoción aplicada a tu platillo.",
                                showConfirmButton: false,
                                timer: 4500
                            });
                            this.reloadProducts()
                        }else{
                            Swal.fire({
                                position: "top-end",
                                icon: "warning",
                                title: "No se ha podido aplicar la promoción al platillo.",
                                showConfirmButton: false,
                                timer: 4500
                            });
                        }
                        this.$bvModal.hide('offers')
                    })
                }
            }
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user
        }
    }
</script>

<template>

    <b-modal 
        id="offers" 
        centered
        hide-footer="true"
        hide-header="true"
        size="md"
        >
        
        <div class="row">
            <div class="col-md-12">
                <h4 class="pedido-welly-text">
                    ¿Deseas 
                    <b class="orange">modificar</b>
                    el descuento de este plato en tu tienda?
                </h4> 
                <h4 class="pedido-welly-text">
                    Seleccione la opción que desea:
                </h4> 
            </div>
        </div>

        <br/>

        <div class="row">
            <div class="col-md-3" @click="setSelected(1)">
                <div :class="{'promo-container': (selected!=1), 'promo-container-selected': (selected===1)}">
                    <div class="promo-container-padding">
                        <span class="pedido-welly-text">
                            <b style="font-size: 1.2em;">
                                SIN
                                <br/>
                                PROMO
                            </b>
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
            <div class="col-md-3" @click="setSelected(2)">
                <div :class="{'promo-container': (selected!=2), 'promo-container-selected': (selected===2)}">
                    <div class="promo-container-padding">
                        <span class="pedido-welly-text">
                            <b style="font-size: 1.2em;">
                                5%
                                <br/>
                                OFF
                            </b>
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
            <div class="col-md-3" @click="setSelected(3)">
                <div :class="{'promo-container': (selected!=3), 'promo-container-selected': (selected===3)}">
                    <div class="promo-container-padding">
                        <span class="pedido-welly-text">
                            <b style="font-size: 1.2em;">
                                10%
                                <br/>
                                OFF
                            </b>
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
            <div class="col-md-3" @click="setSelected(4)">
                <div :class="{'promo-container': (selected!=4), 'promo-container-selected': (selected===4)}">
                    <div class="promo-container-padding">
                        <span class="pedido-welly-text">
                            <b style="font-size: 1.2em;">
                                15%
                                <br/>
                                OFF
                            </b>
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
        </div>

        <br/>

        <div class="row">
            <div class="col-md-3" @click="setSelected(5)">
                <div :class="{'promo-container': (selected!=5), 'promo-container-selected': (selected===5)}">
                    <div class="promo-container-padding">
                        <span class="pedido-welly-text">
                            <b style="font-size: 1.2em;">
                                20%
                                <br/>
                                OFF
                            </b>
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
            <div class="col-md-3" @click="setSelected(6)">
                <div :class="{'promo-container': (selected!=6), 'promo-container-selected': (selected===6)}">
                    <div class="promo-container-padding">
                        <span class="pedido-welly-text">
                            <b style="font-size: 1.2em;">
                                25%
                                <br/>
                                OFF
                            </b>
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
            <div class="col-md-3" @click="setSelected(7)">
                <div :class="{'promo-container': (selected!=7), 'promo-container-selected':  (selected===7)}">
                    <div class="promo-container-padding">
                        <span class="pedido-welly-text">
                            <b style="font-size: 1.2em;">
                                50%
                                <br/>
                                OFF
                            </b>
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
            <div class="col-md-3" @click="setSelected(8)">
                <div :class="{'promo-container': (selected!=8), 'promo-container-selected': (selected===8)}">
                    <div class="promo-container-padding">
                        <span class="pedido-welly-text">
                            <b style="font-size: 1.2em;">
                                
                                <br/>
                                2X1
                            </b>
                        </span> 
                        <br/>
                    </div>
                </div>
            </div>
        </div>

        <br/>

        <div class="row">
            <div class="col-md-12">
                <div class="right">
                    <b-button href="#" type="submit" variant="primary" @click="closeModal()" class="btn-primary">
                        Volver
                    </b-button>
                    <b-button href="#" type="submit" variant="success" @click="applyDisccount()" class="btn-success">
                        Aceptar
                    </b-button>
                </div>
            </div>
        </div>


        <template v-slot:modal-footer>
            <b-button variant="secondary" @click="closeModal()"
                >Close</b-button
            >
        </template>
    </b-modal>
    
</template>
